// extracted by mini-css-extract-plugin
export var highlightEnable = "styles-module--highlightEnable--f0fd5";
export var highlighted = "styles-module--highlighted--dc6ff";
export var hoverEnable = "styles-module--hoverEnable--9ecbd";
export var paddingSidebar = "styles-module--paddingSidebar--67f8e";
export var standard = "styles-module--standard--b6110";